// client/src/components/common/LanguageSelector.tsx
import React, { useState } from 'react';
import { SUPPORTED_LANGUAGES } from '../../services/languageService';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { currentLanguage, changeLanguage, languageNames } = useLanguage();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleLanguageChange = async (code: string) => {
    // Dropdown schließen
    setIsOpen(false);
    
    // Sprache über Context aktualisieren
    await changeLanguage(code);
    
    // Seite neu laden, um die neue Sprache auf alle Komponenten anzuwenden
    window.location.reload();
  };

  // Den Namen der aktuellen Sprache finden
  const getCurrentLanguageName = () => {
    return languageNames[currentLanguage] || 'English';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
      >
        <GlobeAltIcon className="h-5 w-5 mr-1" />
        {/* FIX: Das Class-Handling für den Sprachnamen auf Mobilgeräten explizit machen */}
        <span className="hidden md:inline">{getCurrentLanguageName()}</span>
        {/* FIX: Auf mobilen Geräten nur das Icon anzeigen, nicht aber den Text verstecken */}
        <span className="md:hidden sr-only">Language</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-gray-700 ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {SUPPORTED_LANGUAGES.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`block px-4 py-2 text-sm w-full text-left ${
                  currentLanguage === language.code
                    ? 'bg-gray-600 text-destiny-gold'
                    : 'text-gray-300 hover:bg-gray-600'
                }`}
                role="menuitem"
              >
                {language.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;